module.exports = __webpack_public_path__ + "static/media/changePassword.4060a0f0.svg";